// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__hkCoP","description":"PatientConsentPreview_description__1V4FS"};